module.exports = __webpack_public_path__ + "img/arrowRightDisabled.1310ad86.svg";